import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { PeopleListRow } from 'api/account-people/types';
import { keyBy } from 'lodash';

export const transformPeopleListRow = (
  row: PeopleListRow,
  fields: FilterableField[],
): Record<string, any> => {
  const fieldLookup = keyBy(fields, 'fieldId');
  const { title, ...rest } = row;

  return {
    ...rest,
    ...row.user,
    role: row.user.role?.roleId,
    ...row.user.fields?.reduce(
      (acc, field) => {
        const targetField = fieldLookup[field.fieldId];

        if (targetField) {
          acc[targetField.fieldName] = field.fieldValue;
        }

        return acc;
      },
      {} as Record<string, any>,
    ),
  };
};
